import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import Seo from "@/components/Seo";

export default function BrandSignIn() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("idle");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) return;
    setStatus("exchanging");
    // Cookie is set server-side by this exchange call.
    http.get(`/brand/auth/exchange?token=${encodeURIComponent(token)}`)
      .then(() => {
        toast.success("Signed in");
        nav("/brand/dashboard", { replace: true });
      })
      .catch((e) => {
        setStatus("error");
        toast.error(e.response?.data?.detail || "Invalid link");
      });
  }, [params, nav]);

  const requestLink = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await http.post("/brand/auth/request-link", { email });
      setStatus("sent");
    } catch { toast.error("Failed"); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Seo title="Brand sign-in" description="Brand-rep sign-in via magic link." canonicalPath="/brand/sign-in" locale="en" />
      <div className="bp-container py-16 max-w-md">
        <h1 className="font-serif text-4xl mb-4">Brand sign-in</h1>
        {status === "exchanging" && <p style={{ color: "var(--bp-text-secondary)" }}>Signing you in…</p>}
        {status === "sent" && (
          <div className="p-6 bg-white border" style={{ borderColor: "var(--bp-border)" }} data-testid="link-sent">
            If your email is registered as a brand rep, a sign-in link is on its way.
          </div>
        )}
        {(status === "idle" || status === "error") && (
          <form onSubmit={requestLink} className="space-y-3 p-6 bg-white border" style={{ borderColor: "var(--bp-border)" }}>
            <p className="text-sm" style={{ color: "var(--bp-text-secondary)" }}>Enter your work email and we&apos;ll send you a one-time sign-in link.</p>
            <Input required type="email" placeholder="you@yourbrand.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="brand-signin-email" />
            <Button type="submit" disabled={busy} className="rounded-none w-full" data-testid="brand-signin-submit">Send sign-in link</Button>
            <p className="text-xs" style={{ color: "var(--bp-text-muted)" }}>Not claimed yet? <Link to="/brands" className="bp-link">Find your brand</Link> and click &quot;Is this your brand?&quot;.</p>
          </form>
        )}
      </div>
    </>
  );
}
